export default "__VITE_ASSET__OQHYbBTL__"